
import { useAuth } from "../context/authContext";
import { Navigate } from 'react-router-dom'
import BackgroundStyle from "../components/ui/BackgroundStylePage";

export function RedirectPages({ children }) {
    const {user, loading} = useAuth()
    if(loading){
        return (<>  
            <BackgroundStyle></BackgroundStyle>
        </>)
    }
    
    if(user) return <Navigate to='/home' />

    return (
        <div>{children}</div>
    )
}
